export default "__VITE_ASSET__B8$Oe1pP__"